export const analyticsId = {
  BROKER_HIRE_INVESTMENT_FUND_STEP_1_VIEW: 'BROKER_HIRE_INVESTMENT_FUND_STEP_1_VIEW',
  BROKER_HIRE_INVESTMENT_FUND_STEP_2_VIEW: 'BROKER_HIRE_INVESTMENT_FUND_STEP_2_VIEW',
  BROKER_HIRE_INVESTMENT_FUND_STEP_1_SUCCESS: 'BROKER_HIRE_INVESTMENT_FUND_STEP_1_SUCCESS',
  BROKER_HIRE_INVESTMENT_FUND_STEP_2_SUCCESS: 'BROKER_HIRE_INVESTMENT_FUND_STEP_2_SUCCESS',
  BROKER_HIRE_INVESTMENT_FUND_ERROR: 'BROKER_HIRE_INVESTMENT_FUND_ERROR',
  BROKER_HIRE_INVESTMENT_FUND_SUCCESS: 'BROKER_HIRE_INVESTMENT_FUND_SUCCESS',
};

const commonFields = productName => ({
  sectionFamily: 'wealth',
  sectionCategory: 'products',
  sectionName: 'alternativeFunds',
  serviceType: 'productContracting',
  interactionType: 'funnel',
  processType: 'buyAlternativeFunds',
  productName,
});

export const catalogue = {
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_1_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_investment_details',
    pageName: '/buyAlternativeFunds/step1/investmentDetails',
    processStep: 'step1',
    processDetail: 'investmentDetails',
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_2_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_terms_conditions',
    pageName: '/buyAlternativeFunds/step2/termsConditions',
    processType: 'buyAlternativeFunds',
    processStep: 'step2',
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_1_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'investmentDetails',
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_2_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'termsConditions',
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_ERROR]: ({ productName, errorMessage }) => ({
    ...commonFields(productName),
    event_name: 'step_error',
    pageName: '/buyAlternativeFunds/error/genericError',
    processStep: 'error',
    processDetail: 'genericError',
    errorCategory: 'genericError',
    errorDescription: errorMessage,
  }),
  [analyticsId.BROKER_HIRE_INVESTMENT_FUND_SUCCESS]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_success',
    pageName: '/buyAlternativeFunds/success',
    processStep: 'success',
  }),
};
